import { render, staticRenderFns } from "./basicLayout2.vue?vue&type=template&id=21909191&scoped=true"
import script from "./basicLayout2.vue?vue&type=script&lang=js"
export * from "./basicLayout2.vue?vue&type=script&lang=js"
import style0 from "./basicLayout2.vue?vue&type=style&index=0&id=21909191&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21909191",
  null
  
)

export default component.exports